import React from 'react';
import { useNavigate } from 'react-router-dom';

const NavbarUsuario = () => {
  const navigate = useNavigate();
  const nombreUsuario = localStorage.getItem('userName');

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userRole');
    localStorage.removeItem('userName');
    localStorage.removeItem('programaId');
    navigate('/loginusuario');
  };

  return (
    <nav className="bg-stone-800 text-white shadow-lg">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-4">
            <img 
              src={`${process.env.PUBLIC_URL}/lgo-udi-blanco.png`}
              alt="Logo UDI" 
              className="h-8"
            />
            <span className="font-semibold text-xl">
              Revisión de Matrícula
            </span>
          </div>
          
          <div className="flex items-center space-x-4">
            <span className="text-sm">
              Bienvenido(a), {nombreUsuario || 'Usuario'}
            </span>
            <button
              onClick={handleLogout}
              className="bg-white hover:bg-neutral-200 text-neutral-950 px-4 py-2 rounded-md text-sm transition duration-300"
            >
              Cerrar Sesión
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavbarUsuario;